/**
 * How many site photos a new time report needs.
 *
 * Hours on tasks marked photosNotRequiredInTimeReport do not count.
 * A report made only of those tasks needs no photos.
 * 4 hours or less on the remaining tasks needs 2 photos; above 4 needs 4.
 * A subtask follows its parent task. A row with no task (or an unknown task)
 * still requires photos.
 *
 * Pass entries: null for a report that has no task list (uses reportHours).
 * Pass entries: [] when the worker has not added any task rows yet.
 */

function toHours(value) {
  if (value === undefined || value === null || value === "") return null;
  const parsed =
    typeof value === "number" ? value : parseFloat(String(value).replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
}

function entryHours(value) {
  const hours = toHours(value);
  return hours === null ? 0 : hours;
}

function photosForHours(hours) {
  return hours > 4 ? 4 : 2;
}

function findTask(tasks, taskId) {
  if (taskId === undefined || taskId === null || taskId === "") return null;
  const id = String(taskId);
  return (tasks || []).find((task) => task && String(task._id) === id) || null;
}

function isOptedOut(entry, tasks) {
  if (!entry?.taskId) return false;
  const task = findTask(tasks, entry.taskId);
  if (!task) return false;
  return task.photosNotRequiredInTimeReport === true;
}

export function formatPhotoHours(hours) {
  const parsed = toHours(hours);
  if (parsed === null) return "0";
  return String(Math.round(parsed * 10) / 10);
}

export function reportPhotoRequirement({
  isAbsent = false,
  entries = null,
  tasks = [],
  reportHours = null,
} = {}) {
  if (isAbsent) {
    return { requiredCount: 0, photoRequiredHours: 0, allTasksOptedOut: false };
  }

  if (!Array.isArray(entries)) {
    const hours = toHours(reportHours);
    if (hours === null) {
      return { requiredCount: 0, photoRequiredHours: 0, allTasksOptedOut: false };
    }
    return {
      requiredCount: photosForHours(hours),
      photoRequiredHours: hours,
      allTasksOptedOut: false,
    };
  }

  if (entries.length === 0) {
    return { requiredCount: 0, photoRequiredHours: 0, allTasksOptedOut: false };
  }

  let photoRequiredHours = 0;
  let optedOutCount = 0;
  for (const entry of entries) {
    if (isOptedOut(entry, tasks)) {
      optedOutCount += 1;
    } else {
      photoRequiredHours += entryHours(entry?.hours);
    }
  }

  const allTasksOptedOut = optedOutCount === entries.length;
  if (allTasksOptedOut) {
    return { requiredCount: 0, photoRequiredHours: 0, allTasksOptedOut: true };
  }

  return {
    requiredCount: photosForHours(photoRequiredHours),
    photoRequiredHours,
    allTasksOptedOut: false,
  };
}
